import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { apiGet, apiPost } from 'tennders-stracture/libs/api'
import useSocket from 'tennders-common/hooks/useSocket'
import { StateType } from 'tennders-common/types/StateType'
import { useToast } from 'tennders-common/hooks/useToast'
import { dispatchCarriers, dispatchSelectedRows } from 'tennders-common/stores/data/action'
import { dispatchMultiEditMode, dispatchMultiSelectMode } from 'tennders-common/stores/view/action'

type Props = {
  modal?: {
    className ?:string,
    withForm ?: boolean,
    singleTransaction ?: boolean,
    withoutMarketPlace?: boolean,
    onSelect ?: (params)=>void,
    onSelectMp ?: (params)=>void,
    transactionId ?: number
  },
  onClose ?: ()=>void,
}

const useShareLoad = ({ onClose, modal }: Props) => {
  const { withoutMarketPlace, withForm, onSelect, transactionId } = modal
  const [form, setForm] = useState({})
  const [query, setQuery] = useState('')
  const [allSelected, setAllSelected] = useState(false)
  const [filtereds, setFiltereds] = useState([])
  const onChange = (k, v) => setForm({ ...form, [k]: v })
  const [saving, setSaving] = useState(false)
  const [loading, setLoading] = useState(false)
  const carriers = useSelector((state:StateType) => state.data.carriers)
  const selectedRows = useSelector((state: StateType) => state.data.selectedRows)
  const { toastSuccess, toastError } = useToast()
  const dispatch = useDispatch()
  const setCarriers = (carriers) => dispatch(dispatchCarriers(carriers))
  const setMultiSelectMode = (mode) => dispatch(dispatchMultiSelectMode(mode))
  const setEditMode = (mode) => dispatch(dispatchMultiEditMode(mode))
  const setSelectedRows = (rows) => dispatch(dispatchSelectedRows(rows))
  const { setRefresh } = useSocket()
  const loadCarriers = useCallback(async () => {
    setLoading(true)
    const sharedWith = transactionId ? await apiGet(`/broker/${transactionId}/sharedWith`) : null
    const response = await apiGet('carrier/companies', { params: { attributes: '{id, name, users{id, name}}' } })
    if (response && Array.isArray(response)) {
      setCarriers(response)
      const f = { ...form }
      response.forEach((carrier) => {
        carrier?.users?.forEach((user) => {
          if (sharedWith && Array.isArray(sharedWith) && sharedWith.indexOf(user?.id) > -1) {
            f[`companies_${carrier.id}`] = true
            f[`carriers_${user.id}`] = true
          }
        })
      })
      setForm(f)
    }
    setLoading(false)
  }, [transactionId])

  const selectAll = () => {
    if (allSelected) {
      setForm({})
      setAllSelected(false)
    } else {
      const f = { ...form }

      carriers.forEach((carrier) => {
        f[`companies_${carrier.id}`] = true
        carrier?.users?.forEach((user) => {
          f[`carriers_${user.id}`] = true
        })
      })
      setForm(f)
      setAllSelected(true)
    }
  }

  const getUsersAndCompanies = () => {
    const companies = []
    const users = []
    for (let i = 0; i < Object.keys(form).length; i += 1) {
      const key = Object.keys(form)[i]
      if (key.includes('companies_') && form[key] === true) {
        companies.push(key.replace(/companies_/, ''))
      }
      if (key.includes('carriers_') && form[key] === true) {
        users.push(key.replace(/carriers_/, ''))
      }
    }
    return { companies, users }
  }

  const getTransactions = () => {
    const transactions = []
    for (let i = 0; i < Object.keys(selectedRows).length; i += 1) {
      const key = Object.keys(selectedRows)[i]
      if (key.includes('transaction_') && selectedRows[key] === true) {
        transactions.push(key.replace(/transaction_/, ''))
      }
    }
    return transactions
  }

  const share = async () => {
    const { companies, users } = getUsersAndCompanies()
    const transactions = getTransactions()
    const params = {
      transactions,
      companies,
      users
    }
    setSaving(true)
    const response = await apiPost('broker/shareTransactions', params)
    setSaving(false)
    if (response.error) {
      toastError(response.error)
      return
    }
    toastSuccess('Updated successfully')
    setEditMode(false)
    setMultiSelectMode(false)
    setSelectedRows([])
    setRefresh('all')
    onClose()
  }

  useEffect(() => {
    if (onSelect) {
      onSelect(getUsersAndCompanies())
    }
  }, [form])

  useEffect(() => {
    if (query.length === 0) {
      setFiltereds(carriers)
      return
    }
    const f = []
    for (let i = 0; i < carriers.length; i += 1) {
      const filteredUsers = carriers[i]?.users?.filter((user) => user?.name?.toLowerCase().includes(query.toLowerCase()))
      if (carriers[i]?.name?.toLowerCase().includes(query.toLowerCase())) {
        f.push(carriers[i])
      } else if (filteredUsers?.length > 0) {
        carriers[i].users = filteredUsers
        f.push(carriers[i])
      }
    }
    setFiltereds(f)
  }, [query, carriers])

  useEffect(() => {
    if (transactionId || modal) {
      loadCarriers()
    }
  }, [transactionId, modal])

  return {
    carriers: filtereds,
    loading,
    saving,
    query,
    share,
    setForm,
    onChange,
    filterBy: setQuery,
    selectAll,
    withForm,
    allSelected,
    form,
    withoutMarketPlace,
    transactionId
  }
}

export default useShareLoad
